<!-- 头部 -->
<template>
    <div class="header-content display-y-center display-s-b" :class="(store.state.isShowPWA&&route.path=='/')?'show-PWA':''">
        <div class="display-y-center">
            <img class="logo" src="@/assets/images/header/logo_icon.png" />
        </div>
        <div class="my-gold-bg display-s-b display-y-center">
            <div class="display-y-center">
                <img class="gold-icon" :src="require('@/assets/images/common/' + t('home.img.1'))" />
            </div>
            <div class="display-y-center">
                <span class="gold-text">{{ gold }}</span>
            </div>
            <div class="btn-add display-y-center display-x-center" @click="router.push('/deposit')">
                <img src="@/assets/images/header/add_icon.png" />
            </div>
        </div>
    </div>
</template>
  
<script setup lang="ts">
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { computed, onBeforeMount, reactive } from 'vue';
import { changeMoney } from '@/utils/currencyUtils';
import { freshBalance } from '@/handle/balanceHandle';
import { addTimer, removeTimer } from '@/handle/timerHandle';
import { LOCAL_STORE } from '@/config/constConfig';

const router = useRouter();
const route = useRoute();
const store = useStore();
const { t } = useI18n();

const state = reactive({
    isShowMyInfo: false as boolean
});
//昵称
let nickName = computed(()=> {
    return store.state.nickName;
})
//vip等级
let vipLevel = computed(()=> {
    return store.state.accountInfo.vipLevel;
})
//余额
let gold = computed(()=> {
    return changeMoney(store.state.accountInfo.gold);
})

function isShowGold() {
    let path = route.path;
    if (path.indexOf('/userInfo') != -1) {
        return false;
    }
    return true;
}

onBeforeMount(() => {
    addTimer("freshBalance", ()=> {
        if (store.state.token) {
            let isFresh = localStorage.getItem(LOCAL_STORE.IS_SHOW_NEWPLAYER);
            if (isFresh == "1") {
                freshBalance();
                removeTimer("freshBalance");
            }
        }
    }, 500);
});

</script>

<style lang="less" scoped>
.header-content {
    width: 100%;
    max-width: @max-width;
    height: @header-height;
    background: #0F1D29;
    position: fixed;
    top: 0;
    z-index: 10;
    padding: 0 10rem;
    box-sizing: border-box;
    &.show-PWA {
        margin-top: 40rem;
    }
    .header-icon {
        width: 38rem;
    }
    .logo{
        // width: 113.5rem;
        height: 20rem;
    }
    .my-info {
        color: #FFF;
        font-weight: bold;
        margin-left: 10rem;
        .my-name {
            font-size: 13rem;
        }
    }
    .my-gold-bg {
        min-width: 133.5rem;
        border-radius: 5rem;
        background-color: #162A3B;
        padding: 5rem;
        box-sizing: border-box;
        .gold-icon {
            width: 22rem;
        }
        .gold-text {
            font-family: Roboto;
            font-weight: 700;
            font-size: 16rem;
            color: #FFFFFF;

            margin: 0 5rem
        }
        .arrow{
            width: 15rem;
            margin-right: 5rem;
        }
        .btn-add {
            width: 33rem;
            height: 33rem;
            background: #FFD645;
            border-radius: 4rem;
            >img {
                width: 15rem;
            }
        }
    }
    
}
</style>